import React, { useCallback, useEffect, useState } from 'react';

/** Minimal settings drawer for mall display — camera selection + debug log export. */
const AdhocSettingsBars: React.FC<{
  open: boolean;
  onClose: (args: { cameraId?: string }) => void;
  cameras?: MediaDeviceInfo[];
  isLicenseValid?: boolean;
  onDownloadLog?: () => void;
}> = ({ open, onClose, cameras, onDownloadLog }) => {
  const [isClosing, setIsClosing] = useState(false);
  const [cameraId, setCameraId] = useState<string>();

  useEffect(() => {
    if (cameras?.length) {
      setCameraId((prev) => prev ?? cameras[0].deviceId);
    }
  }, [cameras]);

  useEffect(() => {
    if (open) document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const handleClose = useCallback(() => {
    setIsClosing(true);
    setTimeout(() => {
      onClose({ cameraId });
      setIsClosing(false);
    }, 260);
  }, [cameraId, onClose]);

  return (
    <div id="settingsBars">
      {(open || isClosing) && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 200 }}>
          <div
            onClick={handleClose}
            style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(0,0,0,0.38)',
              opacity: isClosing ? 0 : 1,
              transition: 'opacity 0.25s',
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              bottom: 0,
              width: Math.min(360, window.innerWidth),
              background: '#ffffff',
              boxShadow: '-4px 0 32px rgba(0,0,0,0.14)',
              transform: isClosing ? 'translateX(100%)' : 'translateX(0)',
              transition: 'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
              padding: 24,
            }}
          >
            <h2 style={{ margin: '0 0 16px', fontSize: 18, fontWeight: 700 }}>Camera</h2>
            <select
              value={cameraId || ''}
              onChange={(e) => setCameraId(e.target.value)}
              style={{
                width: '100%',
                padding: 12,
                borderRadius: 10,
                border: '1px solid #e2e8f0',
                fontSize: 14,
              }}
            >
              {(cameras || []).map((c) => (
                <option key={c.deviceId} value={c.deviceId}>
                  {c.label || c.deviceId}
                </option>
              ))}
            </select>
            {onDownloadLog && (
              <button
                type="button"
                onClick={onDownloadLog}
                style={{
                  marginTop: 16,
                  width: '100%',
                  padding: '12px 0',
                  borderRadius: 10,
                  border: '1px solid #e2e8f0',
                  background: '#f8fafc',
                  color: '#334155',
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: 'pointer',
                }}
              >
                Download debug log
              </button>
            )}
            <button
              type="button"
              onClick={handleClose}
              style={{
                marginTop: 20,
                width: '100%',
                padding: '14px 0',
                borderRadius: 12,
                border: 'none',
                background: '#0f172a',
                color: '#fff',
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Done
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdhocSettingsBars;
